export * from "./button/index-ja-jp";
export * from "./button-layer/index-ja-jp";
export * from "./chart-line/index-ja-jp";
export * from "./embedded-acceptor-edge/index-ja-jp";
export * from "./input/index-ja-jp";
export * from "./table/index-ja-jp";
